export type TUserRole = typeof ROLES[number];
export const ADMIN = 'ADMIN';
export const CUSTOMER = 'CUSTOMER';
export const CUSTOMER_ADMIN = 'CUSTOMER_ADMIN';
export const CLIENT = 'CLIENT';
export const EMPLOYEE = 'EMPLOYEE';
export const SUPPORT_1 = 'SUPPORT_1';
export const FIRM = 'FIRM';
export const FIRM_EMPLOYEE = 'FIRM_EMPLOYEE';

export const ROLES = [
  ADMIN,
  CUSTOMER,
  CUSTOMER_ADMIN,
  CLIENT,
  EMPLOYEE,
  SUPPORT_1,
  FIRM,
  FIRM_EMPLOYEE,
] as const;
export const CLIENT_ONLY: TUserRole[] = [CLIENT];
export const STAFF_USERS: TUserRole[] = [ADMIN, SUPPORT_1];
export const CUSTOMER_RELATED_NO_FIRM: TUserRole[] = [CUSTOMER, CUSTOMER_ADMIN];
export const CUSTOMER_RELATED: TUserRole[] = [CUSTOMER, CUSTOMER_ADMIN, FIRM];
export const OTHER_THAN_CLIENT: TUserRole[] = ROLES.filter(role => role !== CLIENT);

// zones
export const TRANSACTION_RULE_BULK_UPDATE = 'transaction.rule:bulk_update';
export const TRANSACTION_RULE_GLOBAL_MANAGE = 'transaction.rule:global_manage';
// an employee the owner or an admin lets assign clients to the team (card #1502)
export const EMPLOYEE_CLIENT_ASSIGN = 'employee.client:assign';
